// components/aside/MobileAside.js
import React, { useState, useEffect } from "react";
import { icons } from "./icons";
import { useNavigate, useLocation } from "react-router-dom";
import { setLoginData } from "../../redux/slices/userSlice";

const MobileAside = ({ onClose, isOpen }) => {
  const [activeItemId, setActiveItemId] = useState("/dashboard");
  const navigate = useNavigate();
  const location = useLocation();
  const [partnerinfo, setPartnerInfo] = useState({});

  useEffect(() => {
    setActiveItemId(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));

    if (userData?.partnerName) {
      setPartnerInfo({
        partnerName: userData.partnerName,
        partnerLogo: userData.partnerLogo || null,
      });
    }
  }, []);

  const handleClick = (item) => {
    if (item === "/") {
      setLoginData(false);
      localStorage.removeItem("userData");
    }
    setActiveItemId(item);
    navigate(item);
    onClose();
  };

  const handleIconClick = () => {
    setActiveItemId("/dashboard");
    navigate("/dashboard");
    onClose();
  };

  const toggleSidebar = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 ">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-[#0000004D]" onClick={onClose} />

      {/* Animated Aside Panel */}
      <div
        className={`min-w-[280px] absolute top-0 left-0 h-full w-64 bg-white rounded-tr-[16px] rounded-br-[16px]
        shadow-[4px_4px_16px_0px_#22245C1F] z-50 transition-transform duration-300 ease-in-out flex flex-col
        ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        {/* Content area that expands */}
        <div className="flex flex-col flex-grow">
          {/* Logo */}
          <div className="min-h-[97px] px-6 py-6">
            <img
              src="/assets/MobileMyserviceLogo.png"
              alt="Logo"
              onClick={handleIconClick}
              className="cursor-pointer"
            />
          </div>

          {/* Menu Items */}
          <div
            className="flex flex-col items-center gap-1 py-6 px-6 overflow-y-auto max-h-[calc(100vh-200px)]
"
          >
            {icons.map((item) => (
              <div
                key={item.id}
                onClick={() => handleClick(item.path)}
                className={`flex w-full gap-3 py-2.5 px-5 ${
                  activeItemId === item.path
                    ? "bg-primary text-white"
                    : "hover:bg-lightOrange hover:text-primary"
                } rounded-[99px] cursor-pointer`}
              >
                <div className="flex items-center">
                  {item.svg(activeItemId === item.path ? "#FFFFFF" : "#181F46")}
                </div>
                <span
                  className={`prose-t16_medium ${
                    activeItemId === item.path ? "text-white" : ""
                  }`}
                >
                  {item.section}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex justify-between py-6 px-6 border-t border-gray-200">
          <div className="flex gap-3">
            {partnerinfo?.partnerLogo ? (
              <img
                src={partnerinfo.partnerLogo}
                alt="partner logo"
                className="w-[40px] h-[40px] rounded-full"
              />
            ) : (
              <svg
                fill="#BFBFBF"
                height="40px"
                width="40px"
                viewBox="0 0 512.001 512.001"
                xmlns="http://www.w3.org/2000/svg"
                className="rounded-full"
              >
                <g>
                  <path
                    d="M160.235,276.571l-144.5-159.983c-9.383,5.578-15.734,15.711-15.734,27.414v256.005c0,17.672,14.328,31.994,32,31.994
                        h268.625l-58.867-65.17C196.993,360.155,162.407,322.662,160.235,276.571z"
                  />
                  <path
                    d="M480.001,112.001h-112l-23.156-46.313c-5.422-10.84-16.5-17.687-28.625-17.687H195.782
                        c-12.125,0-23.203,6.848-28.625,17.688l-10.836,21.672L87.782,10.594C75.985-2.539,55.735-3.61,42.594,8.211
                        c-13.141,11.828-14.203,32.063-2.375,45.196l399.992,448c6.313,7.024,15.031,10.594,23.797,10.594
                        c7.625,0,15.281-2.711,21.391-8.211c13.141-11.828,14.203-32.067,2.375-45.2l-23.734-26.59h15.961c17.672,0,32-14.321,32-31.994
                        V144.002C512.001,126.33,497.672,112.001,480.001,112.001z M237.196,177.94c6.086-1.219,12.359-1.938,18.805-1.938
                        c53.016,0,96,42.981,96,96.002c0,10.223-1.758,19.996-4.727,29.227L237.196,177.94z"
                  />
                </g>
              </svg>
            )}
            <div className="flex flex-col items-start">
              <span className="prose-t12_medium text-slateGray">
                Բարի վերադարձ
              </span>
              <span className="prose-t12_bold text-midnightBlue">
                {partnerinfo?.partnerName}
              </span>
            </div>
          </div>
          <button
            onClick={toggleSidebar}
            className="text-gray-600 hover:text-primary focus:outline-none"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="25"
                height="25"
                rx="12.5"
                fill="white"
              />
              <rect
                x="0.5"
                y="0.5"
                width="25"
                height="25"
                rx="12.5"
                stroke="#E2E8F0"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1658 9.23431C15.4782 9.54673 15.4782 10.0533 15.1658 10.3657L12.5315 13L15.1658 15.6343C15.4782 15.9467 15.4782 16.4533 15.1658 16.7657C14.8534 17.0781 14.3468 17.0781 14.0344 16.7657L10.8344 13.5657C10.522 13.2533 10.522 12.7467 10.8344 12.4343L14.0344 9.23431C14.3468 8.9219 14.8534 8.9219 15.1658 9.23431Z"
                fill="#081021"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileAside;
